import {
    ENTITY_PART_TYPE_RATE,
    ENTITY_PART_TYPE_SEPARATOR,
} from '_legacy/models/common/EntityPart';
import { balticIndexValue, flatRateValue, sparkIndexValue } from './RateTypes';

const START_VALUE_FOR_ROUNDING = 1000;
export const NET_RATE_FIXED_OPTION_NAME = 'NET';

export const createFlatRatePart = (params) => {
    const {
        currency,
        unit,
        amountFrom,
        amountTo,
        bound,
        durationAmountFrom,
        durationAmountTo,
        durationUnit,
        balticRoute,
        info,
        isEquiv,
    } = params;

    const flatRate = createFlatRate(
        currency,
        unit,
        amountFrom,
        amountTo,
        bound,
        balticRoute,
        info,
        isEquiv
    );
    const duration = createDuration(
        durationAmountFrom,
        durationAmountTo,
        durationUnit
    );
    const rateValue = createRateValue(
        flatRateValue,
        flatRate,
        null,
        null,
        duration
    );

    return createPart(rateValue, null, ENTITY_PART_TYPE_RATE);
};

export const createBalticIndexPart = (params) => {
    const {
        amountFrom,
        amountTo,
        index,
        durationAmountFrom,
        durationAmountTo,
        durationUnit,
    } = params;

    const balticIndex = createBalticIndex(amountFrom, amountTo, index);
    const duration = createDuration(
        durationAmountFrom,
        durationAmountTo,
        durationUnit
    );
    const rateValue = createRateValue(
        balticIndexValue,
        null,
        balticIndex,
        null,
        duration
    );

    return createPart(rateValue, null, ENTITY_PART_TYPE_RATE);
};

export const createSparkIndexPart = (params) => {
    const {
        amountFrom,
        amountTo,
        index,
        durationAmountFrom,
        durationAmountTo,
        durationUnit,
    } = params;

    const sparkIndex = createSparkIndex(amountFrom, amountTo, index);
    const duration = createDuration(
        durationAmountFrom,
        durationAmountTo,
        durationUnit
    );
    const rateValue = createRateValue(
        sparkIndexValue,
        null,
        null,
        sparkIndex,
        duration
    );

    return createPart(rateValue, null, ENTITY_PART_TYPE_RATE);
};

export const createSeparatorRatePart = (character) => {
    return createPart(null, character, ENTITY_PART_TYPE_SEPARATOR);
};

const createFlatRate = (
    currency,
    unit,
    amountFrom,
    amountTo,
    bound,
    balticRoute,
    info,
    isEquiv
) => {
    const amount = amountFrom && {
        from: RoundAmount(amountFrom),
        to: RoundAmount(amountTo),
    };
    return {
        currency: currency,
        unit: unit,
        amount: amount,
        bound: bound,
        balticRoute: balticRoute,
        info: info,
        isEquiv: isEquiv,
    };
};

const createBalticIndex = (amountFrom, amountTo, index) => {
    const amount = amountFrom && {
        from: amountFrom,
        to: amountTo,
    };
    return {
        amount: amount,
        index: index,
    };
};

const createSparkIndex = (amountFrom, amountTo, index) => {
    const amount = amountFrom && {
        from: amountFrom,
        to: amountTo,
    };
    return {
        amount: amount,
        index: index,
    };
};

const createDuration = (amountFrom, amountTo, unit) => {
    return !amountFrom
        ? null
        : {
              amount: { from: amountFrom, to: amountTo },
              unit: unit,
          };
};

const createRateValue = (type, flatRate, balticIndex, sparkIndex, duration) => {
    return {
        type: type,
        flatRate: flatRate,
        balticIndex: balticIndex,
        sparkIndex: sparkIndex,
        duration: duration,
    };
};

const RoundAmount = (amount) =>
    amount > START_VALUE_FOR_ROUNDING ? Math.round(amount) : amount;

const createPart = (rateValue, separatorValue, partType) => {
    return {
        partType,
        rateValue,
        separatorValue,
    };
};
